let routes = {
    path: '/',
    component: () =>
        import ('@/views/playout'),
    redirect: '/login',
    children: [{
            path: 'index',
            meta: {
                title: 'Home',
                code: 'router_user_index',
                menucode: 'index',
                keepAlive: true
            },
            component: () =>
                import ('@/views/index'),
        },
        {
            path:'comingsoon',
            meta: {
                title: 'comingsoon',
                code: 'router_comingsoon',
                menucode: 'comingsoon',
                keepAlive: false
            },
            component:()=>import('@/views/coming'),
        },
        {
            path:'jumpPC',
            meta: {
                title: 'jumpPC',
                code: 'router_jumpPC',
                menucode: 'jumpPC',
                keepAlive: false
            },
            component:()=>import('@/views/jumpPC'),
        },
        {
            path: 'keyinfo',
            component: () =>
                import ('@/views/layout'),
            redirect: '/keyinfo/shop',//證書牌照上傳
            children: [{
                    path: 'shop',
                    meta: {
                        title: 'Key Info',
                        code: 'router_user_keyinfo_shop',
                        menucode: 'KeyInfoInfo_keyinfo',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/keyinfo/shop'),
                },
                {
                    path: 'index',
                    meta: {
                        title: 'Key Info',
                        code: 'router_user_keyinfo_index',
                        menucode: 'KeyInfoInfo_keyinfo',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/keyinfo/index'),
                },
                {
                    path: 'edit',
                    meta: {
                        title: 'Key Info',
                        code: 'router_user_keyinfo_edit',
                        menucode: 'KeyInfoInfo_keyinfo',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/keyinfo/edit'),
                },
                {
                    path: 'history',
                    meta: {
                        title: 'Key Info',
                        code: 'router_user_keyinfo_history',
                        menucode: 'KeyInfoInfo_keyinfo',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/keyinfo/history'),
                },
            ]
        },
        {
            path: 'contact',
            component: () =>
                import ('@/views/layout'),
            redirect: '/contact/index',//商戶聯絡更新
            children: [{
                    path: 'index',
                    meta: {
                        title: 'Contact Update',
                        code: 'router_user_contact_index',
                        menucode: 'KeyInfoInfo_contact',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/contact/index'),
                },
                {
                    path: 'edit',
                    meta: {
                        title: 'Contact Info',
                        code: 'router_user_contact_edit',
                        menucode: 'KeyInfoInfo_contact',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/contact/edit'),
                },
                {
                    path: 'history',
                    meta: {
                        title: 'Document Update Record',
                        code: 'router_user_contact_history',
                        menucode: 'KeyInfoInfo_contact',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/contact/history'),
                },
                {
                    path: 'historyDetail',
                    meta: {
                        title: 'Information Update Details',
                        code: 'router_user_contact_historyDetail',
                        menucode: 'KeyInfoInfo_contact',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/contact/historyDetail'),
                },
            ]
        },
        {
            path: 'Eforms',
            component: () =>
                import ('@/views/layout'),
                redirect: '/Eforms/index',//電子表格
                children: [
                    //
                    {
                        path: 'index',
                        meta: {
                            title: 'Eforms',
                            code: 'router_user_Eforms_index',
                            menucode: 'KeyInfoInfo_Eforms',
                            keepAlive: false
                        },
                        component: () =>
                            import ('@/views/Eforms/index'),
                    }
            ]
        },
        {
            path: 'Questionnaire',
            component: () =>
                import ('@/views/layout'),
            redirect: '/Questionnaire/shop',//電子表格
            children: [
                {
                    path: 'shop',
                    meta: {
                        title: 'Key Info',
                        code: 'router_user_keyinfo_QuestionnaireShop',
                        menucode: 'KeyInfoInfo_QuestionnaireShop',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Questionnaire/shop'),
                },
                {
                    path: 'index',
                    meta: {
                        title: 'Questionnaire',
                        code: 'router_user_Questionnaire_index',
                        menucode: 'KeyInfoInfo_Questionnaire',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Questionnaire/index'),
                }
         ]
        },
        {
            path: 'FittingOut',
            component: () =>
                import ('@/views/layout'),
            redirect: '/FittingOut/shop',
            children: [{
                    path: 'shop',
                    meta: {
                        title: 'Shop Fitting-out',
                        code: 'router_user_FittingOut_shop',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false,
                        ifDoFresh: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/shop'),
                },
                {
                    path: 'index',
                    meta: {
                        title: 'Shop Fitting-out',
                        code: 'router_user_FittingOut_index',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false,
                        ifDoFresh: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/index'),
                },
                {
                    path: 'detail',
                    meta: {
                        title: 'Tenant Submission Record',
                        code: 'router_user_FittingOut_detail',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false,
                        ifDoFresh: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/detail'),
                },
                {
                    path: 'disk',
                    meta: {
                        title: 'Tenant Submission Record',
                        code: 'router_user_FittingOut_disk',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/disk'),
                },
                {
                    path: 'view',
                    meta: {
                        title: 'Submitted Files',
                        code: 'router_user_FittingOut_view',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/view'),
                },
                {
                    path: 'SubmissionCheckList',
                    meta: {
                        title: 'Submission CheckList',
                        code: 'router_user_FittingOut_SubmissionCheckList',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/SubmissionCheckList'),
                },
                {
                    path: 'approvedDocuments',
                    meta: {
                        title: 'Submission CheckList',
                        code: 'router_user_FittingOut_approvedDocuments',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/approvedDocuments'),
                },
                {
                    path: 'edit',
                    meta: {
                        title: 'Tenant Submission Record',
                        code: 'router_user_FittingOut_edit',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/edit'),
                },
                {
                    path: 'email',
                    meta: {
                        title: 'Enter Contractor Email',
                        code: 'router_user_FittingOut_email',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/email'),
                },
                {
                    path: 'history',
                    meta: {
                        title: 'Tenant Submission Record',
                        code: 'router_user_FittingOut_history',
                        menucode: 'FittingOut_Submission',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/FittingOut/history'),
                },
            ]
        },
        {
            path: 'Notice',
            component: () =>
                import ('@/views/layout'),
            redirect: '/Notice/index',
            children: [{
                path: 'index',
                meta: {
                    title: 'Notification',
                    code: 'router_user_Notice_index',
                    menucode: 'Notification',
                    keepAlive: true
                },
                component: () =>
                    import ('@/views/Notice/index'),
            }, {
                path: 'detail',
                meta: {
                    title: 'Information Alerts',
                    code: 'router_user_Notice_detail',
                    menucode: 'Notification',
                    keepAlive: false
                },
                component: () =>
                    import ('@/views/Safety/detail'),
            },]
        },
        {
            path: 'User',
            component: () =>
                import ('@/views/layout'),
            redirect: '/User/resetPassword',
            children: [{
                    path: 'resetPassword',
                    meta: {
                        title: 'Reset Password',
                        code: 'router_user_resetPassword',
                        menucode: 'resetPassword',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/user/resetPassword'),
                },
                {
                    path: 'setting',
                    meta: {
                        title: 'Setting',
                        code: 'router_user_setting',
                        menucode: 'setting',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/user/setting'),
                },
            ]
        },
        {
            path: 'Safety',
            component: () =>
                import ('@/views/layout'),
            redirect: '/Safety/index',
            children: [{
                    path: 'index',
                    meta: {
                        title: 'Safety Information',
                        code: 'router_user_Safety_index',
                        menucode: 'Safety',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/index'),
                },
                {
                    path: 'disk',
                    meta: {
                        title: 'Safety Information',
                        code: 'router_user_Safety_disk',
                        menucode: 'Safety',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/disk'),
                },
                {
                    path: 'detail',
                    meta: {
                        title: 'Safety Alerts',
                        code: 'router_user_Safety_detail',
                        menucode: 'Safety',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Safety/detail'),
                },
            ]
        },
        {
            path: 'TenantNotice',
            component: () =>
                import ('@/views/layout'),
            redirect: '/TenantNotice/index',
            children: [{
                    path: 'index',
                    meta: {
                        title: 'TenantNotice Information',
                        code: 'router_user_TenantNotice_index',
                        menucode: 'Customerphone_tenantnotice',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/index'),
                },
                {
                    path: 'disk',
                    meta: {
                        title: 'TenantNotice Information',
                        code: 'router_user_TenantNotice_disk',
                        menucode: 'Customerphone_tenantnotice',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/disk'),
                },
                {
                    path: 'detail',
                    meta: {
                        title: 'TenantNotice Alerts',
                        code: 'router_user_TenantNotice_detail',
                        menucode: 'Customerphone_tenantnotice',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Safety/detail'),
                },
            ]
        },
        {
            path: 'phoneContact',
            component: () =>
                import ('@/views/layout'),
            redirect: '/phoneContact/index',
            children: [{
                    path: 'index',
                    meta: {
                        title: 'Contact Us',
                        code: 'router_user_phoneContact',
                        menucode: 'phoneContact',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/phoneContact/index'),
                },
            ]
        },
        {
            path: 'FittingoutInformation',
            component: () =>
                import ('@/views/layout'),
            redirect: '/FittingoutInformation/index',
            children: [{
                    path: 'index',
                    meta: {
                        title: 'Fitting-out Information',
                        code: 'router_user_FittingOut_Information_index',
                        menucode: 'FittingOut_Information',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/index'),
                },
                {
                    path: 'disk',
                    meta: {
                        title: 'Fitting-out Information',
                        code: 'router_user_FittingOut_Information_disk',
                        menucode: 'FittingOut_Information',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/disk'),
                },
                {
                    path: 'detail',
                    meta: {
                        title: 'Fitting-out Alerts',
                        code: 'router_user_FittingOut_Information_detail',
                        menucode: 'FittingOut_Information',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Safety/detail'),
                },
            ]
        },
        {
            path: 'FittingoutInformationFile',
            component: () =>
                import ('@/views/layout'),
            redirect: '/FittingoutInformationFile/index',
            children: [{
                    path: 'index',
                    meta: {
                        title: 'Fitting-out Technical Information',
                        code: 'router_user_FittingOut_FittingoutInformationFile_index',
                        menucode: 'FittingOut_FittingoutInformationFile',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/index'),
                },
                {
                    path: 'disk',
                    meta: {
                        title: 'Fitting-out Technical Information',
                        code: 'router_user_FittingOut_FittingoutInformationFile_disk',
                        menucode: 'FittingOut_FittingoutInformationFile',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/disk'),
                },
                {
                    path: 'detail',
                    meta: {
                        title: 'Fitting-out Alerts',
                        code: 'router_user_FittingOut_FittingoutInformationFile_detail',
                        menucode: 'FittingOut_FittingoutInformationFile',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Safety/detail'),
                },
            ]
        },
        {
            path: 'WorkApplicationFile',
            component: () =>
                import ('@/views/layout'),
            redirect: '/WorkApplicationFile/index',
            children: [{
                    path: 'index',
                    meta: {
                        title: 'Work Application Appendices',
                        code: 'router_user_FittingOut_WorkApplicationFile_index',
                        menucode: 'FittingOut_WorkApplicationFile',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/index'),
                },
                {
                    path: 'disk',
                    meta: {
                        title: 'Work Application Appendices',
                        code: 'router_user_FittingOut_WorkApplicationFile_disk',
                        menucode: 'FittingOut_WorkApplicationFile',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/disk'),
                },
                {
                    path: 'detail',
                    meta: {
                        title: 'Work Application Appendices',
                        code: 'router_user_FittingOut_WorkApplicationFile_detail',
                        menucode: 'FittingOut_WorkApplicationFile',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Safety/detail'),
                },
            ]
        },
        {
            path: 'ShopOperation',
            component: () =>
                import ('@/views/layout'),
            redirect: '/ShopOperation/index',
            children: [{
                    path: 'index',
                    meta: {
                        title: 'Shop Operation Manual/Guideline',
                        code: 'router_user_ShopOperation_index',
                        menucode: 'Customerphone_ShopOperation',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/index'),
                },
                {
                    path: 'disk',
                    meta: {
                        title: 'Shop Operation Manual/Guideline',
                        code: 'router_user_ShopOperation_disk',
                        menucode: 'Customerphone_ShopOperation',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/Safety/disk'),
                },
                {
                    path: 'detail',
                    meta: {
                        title: 'Shop Operation Manual/Guideline Alerts',
                        code: 'router_user_ShopOperation_detail',
                        menucode: 'Customerphone_ShopOperation',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Safety/detail'),
                },
            ]
        },
        {
            path: 'Report',
            component: () =>
                import ('@/views/layout'),
            redirect: '/Report/shop',
            children: [{
                path: 'shop',
                meta: {
                    title: 'Shop Report',
                    code: 'router_user_Report_shop',
                    menucode: 'Customerphone_RepairReport',
                    keepAlive: false
                },
                component: () =>
                    import ('@/views/Report/shop'),
            },{
                    path: 'index',
                    meta: {
                        title: 'Repair Report',
                        code: 'router_user_Report_index',
                        menucode: 'Customerphone_RepairReport',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Report/index'),
                },
                {
                    path: 'history',
                    meta: {
                        title: 'Repair Report',
                        code: 'router_user_Report_history',
                        menucode: 'Customerphone_RepairReport',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Report/history'),
                },
                {
                    path: 'historyDetail',
                    meta: {
                        title: 'Repair Report',
                        code: 'router_user_Report_historyDetail',
                        menucode: 'Customerphone_RepairReport',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/Report/historyDetail'),
                },
            ]
        },
        {
            path: 'WorkApplication',
            component: () =>
                import ('@/views/layout'),
            redirect: '/WorkApplication/shop',
            children: [{
                path: 'shop',
                meta: {
                    title: 'Shop WorkApplication',
                    code: 'router_user_WorkApplication_shop',
                    menucode: 'FittingOut_WorkApplication',
                    keepAlive: false
                },
                component: () =>
                    import ('@/views/WorkApplication/shop'),
            },{
                    path: 'index',
                    meta: {
                        title: 'Work Application',
                        code: 'router_user_WorkApplication_index',
                        menucode: 'FittingOut_WorkApplication',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/WorkApplication/index'),
                },{
                    path: 'guidelines',
                    meta: {
                        title: 'Guidelines for filling out forms',
                        code: 'router_user_WorkApplication_guidelines',
                        menucode: 'FittingOut_WorkApplication',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/WorkApplication/guidelines'),
                },{
                    path: 'upload',
                    meta: {
                        title: 'Upload',
                        code: 'router_user_WorkApplication_upload',
                        menucode: 'FittingOut_WorkApplication',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/WorkApplication/upload'),
                },{
                    path: 'uploadHistory',
                    meta: {
                        title: 'Upload History',
                        code: 'router_user_WorkApplication_uploadHistory',
                        menucode: 'FittingOut_WorkApplication',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/WorkApplication/uploadHistory'),
                },{
                    path: 'uploadHistoryDetail',
                    meta: {
                        title: 'Upload History',
                        code: 'router_user_WorkApplication_uploadHistoryDetail',
                        menucode: 'FittingOut_WorkApplication',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/WorkApplication/uploadHistoryDetail'),
                },{
                    path: 'apply',
                    meta: {
                        title: 'Application of Works(Station Shop)',
                        code: 'router_user_WorkApplication_apply',
                        menucode: 'FittingOut_WorkApplication',
                        keepAlive: true
                    },
                    component: () =>
                        import ('@/views/WorkApplication/apply'),
                },{
                    path: 'applySubmitter',
                    meta: {
                        title: 'Application of Works(Station Shop)',
                        code: 'router_user_WorkApplication_applySubmitter',
                        menucode: 'FittingOut_WorkApplication',
                        keepAlive: false
                    },
                    component: () =>
                        import ('@/views/WorkApplication/applySubmitter'),
                }
            ]
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/user.js